/** Avatar initials from a person's name: first and last name, or the first two letters of one. */
export function initialsFor(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

type KnownUser = { jt_user_id: string; jt_account_id?: string | null; name: string };

/**
 * The person behind an owner id (JT1-1908). Owner ids are the users_cache person key, which for
 * someone set up before they first signed in is their JobTetris account id, so both are checked.
 */
export function ownerFor(ownerUserId: string, users: KnownUser[] | undefined): { name: string; initials: string } {
  const user = findOwner(ownerUserId, users);
  if (!user) return { name: 'Unknown owner', initials: '?' };
  return { name: user.name, initials: initialsFor(user.name) };
}

/** The users_cache row an owner id points at, matched on either id (see ownerFor). */
export function findOwner<U extends KnownUser>(ownerUserId: string, users: U[] | undefined): U | undefined {
  return users?.find((u) => u.jt_user_id === ownerUserId || u.jt_account_id === ownerUserId);
}
